import React from 'react'
import Link from '../navigation/Link'
import ListModule from '../module/ListModule'
import { textOperators, dateOperators } from '../../utils/constants/operators'
import { buildStatusColumn } from '../fields/StatusField'
import Quote from '../modules/Quotes/Quote'
import DocumentPreview from '../document/DocumentPreview'

const QuoteSubModule = ({ userRight, user, location, statusList }) => {
  const customerId = location?.state?.id ?? null

  const options = {
    tableStyle: { maxHeight: 350, padding: '1px' },
    paperStyle: {},
    accessRight: userRight,
    actions: { go: true },
    objectType: 'quotes',
    objectFilter: () => ({ customer_id: customerId, company_id: user.company_id }),
    isFilter: true,
    isExpand: true,
    defaultSorted: 'quote_number',
    expand: (row) => <DocumentPreview Component={Quote} document={row} />,
    columns: [
      {
        name: 'quote_number',
        label: 'N° Devis',
        isFilter: true,
        operators: textOperators,
        mapping: (id, rowid) => (
          <Link to={`/quotes/view`} state={{ id: rowid?.id, history: '/customers/view' }}>
            {id}
          </Link>
        )
      },
      {
        name: 'quote_date',
        label: 'Date Devis',
        isFilter: true,
        inputType: 'date',
        type: 'date',
        format: 'DD/MM/YYYY',
        operators: dateOperators
      },
      { name: 'total_amount_net', label: 'Montant total', type: 'currency', isFilter: false },
      buildStatusColumn('quotes', statusList)
    ]
  }

  const toolbar = {
    isFilter: true,
    isSubMod: true,
    columns: options.columns,
    style: { marginTop: '5px', marginBottom: '5px' },
    objectType: 'quotes',
    accessRight: userRight,
    actions: { addFor: true },
    getContext: () => ({ customer_id: customerId }),
    columnVisibility: true
  }

  return <ListModule options={options} toolbar={toolbar} />
}

export default React.memo(QuoteSubModule)
